export default "__VITE_ASSET__851e7c89__"